import { c as _c } from "react/compiler-runtime";
import { Center, Spinner } from '@chakra-ui/react';
import { useClarityAdvisorImport } from '@src/components/sco/Advisors/hooks/useClarityAdvisorImport';
import { STANDALONE_ADVISORS_PATHS } from '@src/components/sco/Advisors/paths';
import { ClarityAdvisorImportView } from '@src/components/sco/Advisors/sections/ClarityAdvisorImportView';
import { ScoClarityAdvisorImportClaimStatus } from '@src/graphql-types';
import { prettyErrorMessage } from '@src/lib/mutationErrors';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
export const ClarityAdvisorImportSection = () => {
  const $ = _c(22);
  const router = useRouter();
  const handle = typeof router.query.handle === "string" ? router.query.handle : "";
  const importState = useClarityAdvisorImport(handle);
  const canonical = importState.canonicalScreenName;
  let t0;
  let t1;
  if ($[0] !== canonical || $[1] !== handle || $[2] !== router) {
    t0 = () => {
      if (!router.isReady || !handle || !canonical) {
        return;
      }
      if (canonical !== handle) {
        router.replace(STANDALONE_ADVISORS_PATHS.becomeAnAdvisorClarity(canonical), undefined, {
          shallow: true
        });
      }
    };
    t1 = [canonical, handle, router];
    $[0] = canonical;
    $[1] = handle;
    $[2] = router;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (!router.isReady || importState.loading) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Center minHeight="50vh" width="full"><Spinner colorPalette="orange" size="lg" /></Center>;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  const t2 = importState.claimStatus || ScoClarityAdvisorImportClaimStatus.NotFound;
  let t3;
  if ($[6] !== importState.error || $[7] !== importState.queryError) {
    t3 = importState.error || (importState.queryError ? prettyErrorMessage(importState.queryError) : null);
    $[6] = importState.error;
    $[7] = importState.queryError;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== handle || $[10] !== importState.applyHref || $[11] !== importState.becomeHref || $[12] !== importState.claiming || $[13] !== importState.expert || $[14] !== importState.extracting || $[15] !== importState.holdPhase || $[16] !== importState.isRegistered || $[17] !== importState.loginHref || $[18] !== importState.onConfirm || $[19] !== t2 || $[20] !== t3) {
    t4 = <ClarityAdvisorImportView applyHref={importState.applyHref} becomeHref={importState.becomeHref} claiming={importState.claiming} claimStatus={t2} expert={importState.expert} extracting={importState.extracting} handle={handle} holdPhase={importState.holdPhase} isRegistered={importState.isRegistered} loginHref={importState.loginHref} error={t3} onConfirm={importState.onConfirm} />;
    $[9] = handle;
    $[10] = importState.applyHref;
    $[11] = importState.becomeHref;
    $[12] = importState.claiming;
    $[13] = importState.expert;
    $[14] = importState.extracting;
    $[15] = importState.holdPhase;
    $[16] = importState.isRegistered;
    $[17] = importState.loginHref;
    $[18] = importState.onConfirm;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};